import React from "react";

const Bone = ({ className = "", style }) => (
  <div className={`skeleton-bone rounded ${className}`} style={style} />
);

const CardSkeleton = ({ hasIcon = false }) => (
  <div className="rounded-2xl border border-slate-100 bg-white p-4 shadow-sm">
    <div className="flex items-center gap-3">
      {hasIcon && <Bone className="h-9 w-9 shrink-0 rounded-full" />}
      <div className="min-w-0 flex-1 space-y-2">
        <Bone className="h-3.5 w-[68%] rounded" />
        <Bone className="h-2.5 w-[28%] rounded" />
      </div>
    </div>
    <div className="mt-3 space-y-1.5">
      <Bone className="h-2.5 w-full rounded" />
      <Bone className="h-2.5 w-[78%] rounded" />
    </div>
    <div className="mt-4 flex items-center justify-between">
      <Bone className="h-3 rounded" style={{ width: 56 }} />
      <Bone className="h-7 rounded-full" style={{ width: 92 }} />
    </div>
  </div>
);

const SectionSkeleton = ({ cardCount = 3, hasIcon = false }) => (
  <div className="mb-8 mt-5">
    <div className="mb-5 flex items-center gap-2.5">
      <Bone className="h-6 shrink-0 rounded-full" style={{ width: 3 }} />
      <Bone className="h-3.5 rounded" style={{ width: 124 }} />
      <Bone className="h-5 rounded-full" style={{ width: 72 }} />
      <div className="h-px flex-1 bg-slate-100" />
    </div>
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4">
      {Array.from({ length: cardCount }, (_, i) => (
        <CardSkeleton key={i} hasIcon={hasIcon} />
      ))}
    </div>
  </div>
);

const QueriesTableSkeleton = ({
  showTabs = false,
  showFilterButtons = false,
  hasCardIcon = false,
}) => (
  <div className="w-full">
    {/* Search bar */}
    <div className="mb-4">
      <div className="flex items-center gap-2">
        <Bone className="h-12 flex-1 rounded-xl" />
        {showFilterButtons && (
          <>
            <Bone className="h-12 w-12 shrink-0 rounded-xl" />
            <Bone className="h-12 w-12 shrink-0 rounded-xl" />
          </>
        )}
      </div>
    </div>

    {/* Tabs */}
    {showTabs && (
      <div className="mb-4">
        <div className="inline-flex items-center gap-1 rounded-2xl border border-gray-100 bg-white p-1 shadow-sm">
          {[76, 60, 92, 76].map((w, i) => (
            <Bone key={i} className="h-8 rounded-xl" style={{ width: w }} />
          ))}
        </div>
      </div>
    )}

    {/* Category sections */}
    <SectionSkeleton cardCount={4} hasIcon={hasCardIcon} />
    <SectionSkeleton cardCount={3} hasIcon={hasCardIcon} />
  </div>
);

export default QueriesTableSkeleton;
